import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Sidebar, Footer, Navbar } from "../Components";
import KycBanner from "../Components/kyc-banner/KycBanner";

const KYC_REQUIRED_ROUTES = new Set([
  "/new-transfer",
  "/add-funds",
  "/convert",
  "/create-new-card",
  "/create-company-card",
  "/create-company-card2",
  "/card-setting",
  "/request-money",
  "/split-payment",
  "/qr-payment",
  "/schedule-transfer",
  "/add-recipient",
  "/connect-new-account",
  "/settings",
]);

const SIDEBAR_PREF_KEY = "armf.sidebarExpanded";

const MainLayout = ({
  children,
  NavName,
  navbarChildren,
  hideKyc,
  pageClassName = "",
  contentClassName = "",
  expand,
}) => {
  const location = useLocation();

  /**
   * Whether the sidebar is expanded is the user's choice, remembered between
   * visits. It used to be derived from the page, expanded on Dashboard,
   * collapsed to icons everywhere else, so navigating away silently hid the
   * navigation and there was no way to bring it back. The `expand` prop now
   * only supplies the first-run default.
   */
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(() => {
    const saved = localStorage.getItem(SIDEBAR_PREF_KEY);
    if (saved === "expanded") return true;
    if (saved === "collapsed") return false;
    // Expanded until the user says otherwise. Individual pages still pass
    // expand={false}, which is what used to hide the navigation on most
    // screens; that is now only a hint, not a decision made for the user.
    return true;
  });

  const toggleSidebar = () => {
    setIsSidebarExpanded((open) => {
      const next = !open;
      localStorage.setItem(SIDEBAR_PREF_KEY, next ? "expanded" : "collapsed");
      return next;
    });
  };

  const sidebarWidth = isSidebarExpanded ? 240 : 76;
  const shouldShowKyc =
    !hideKyc &&
    [...KYC_REQUIRED_ROUTES].some((route) =>
      location.pathname === route || location.pathname.startsWith(`${route}/`)
    );

  return (
    <div className="app-layout">
      <div
        className={`app-sidebar-container d-none d-md-block ${
          isSidebarExpanded ? "is-expanded" : "is-collapsed"
        }`}
        style={{ width: sidebarWidth, flexBasis: sidebarWidth }}
      >
        <Sidebar isExpanded={isSidebarExpanded} onToggle={toggleSidebar} />
      </div>

      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <Sidebar isExpanded={true} closeButton={true} />
      </div>

      <main className={`app-main ${pageClassName}`}>
        <Navbar NavName={NavName || "ARM Financial"} divClassName="w-100">
          {navbarChildren}
        </Navbar>

        <div className={`app-content ${contentClassName}`}>
          {shouldShowKyc && <KycBanner />}
          <div className="app-content-body">{children}</div>
          <Footer />
        </div>
      </main>
      </div>
  );
};

export default MainLayout;
